// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--A9oMv","table":"table--1p6mR"};